import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = {
  key: 0,
  class: "loading apollo"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "uk-badge uk-label-green" }
const _hoisted_5 = { class: "uk-badge uk-label-orange" }
const _hoisted_6 = { class: "uk-table uk-table-striped uk-table-hover uk-table-small" }
const _hoisted_7 = {
  key: 0,
  "uk-icon": "icon:triangle-down"
}
const _hoisted_8 = {
  key: 0,
  "uk-icon": "icon:triangle-down"
}
const _hoisted_9 = {
  key: 0,
  "uk-icon": "icon:triangle-down"
}
const _hoisted_10 = {
  key: 0,
  "uk-icon": "icon:triangle-down"
}
const _hoisted_11 = {
  key: 0,
  "uk-icon": "icon:triangle-down"
}
const _hoisted_12 = {
  key: 0,
  "uk-icon": "icon:triangle-down"
}
const _hoisted_13 = {
  key: 0,
  "uk-icon": "icon:triangle-down"
}
const _hoisted_14 = {
  key: 0,
  "uk-icon": "icon:triangle-down"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "uk-text-left" }
const _hoisted_17 = { class: "uk-text-left" }
const _hoisted_18 = { class: "uk-text-left" }
const _hoisted_19 = {
  key: 0,
  class: "uk-text-left"
}
const _hoisted_20 = {
  key: 1,
  class: "uk-text-left"
}
const _hoisted_21 = {
  key: 2,
  class: "uk-text-left"
}
const _hoisted_22 = ["uk-tooltip"]
const _hoisted_23 = {
  key: 4,
  class: "uk-text-left"
}
const _hoisted_24 = {
  key: 5,
  class: "uk-text-left"
}
const _hoisted_25 = { class: "uk-text-left" }
const _hoisted_26 = {
  key: 0,
  class: "uk-label uk-label-warning"
}
const _hoisted_27 = {
  key: 1,
  class: "uk-label uk-label-orange"
}
const _hoisted_28 = {
  key: 2,
  class: "uk-label uk-label-success"
}
const _hoisted_29 = {
  key: 3,
  class: "uk-label uk-label-danger"
}
const _hoisted_30 = {
  key: 4,
  class: "uk-label uk-label-danger"
}
const _hoisted_31 = {
  key: 5,
  class: "uk-label"
}
const _hoisted_32 = {
  key: 6,
  class: "uk-text-left"
}
const _hoisted_33 = {
  key: 7,
  class: "uk-text-left"
}
const _hoisted_34 = {
  key: 8,
  class: "uk-text-left"
}
const _hoisted_35 = { class: "uk-text-left" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Loading..."))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _cache[23] || (_cache[23] = _createElementVNode("nav", {
            id: "mainNavbar",
            class: "uk-navbar-container",
            style: {"background-color":"black"},
            "uk-navbar": ""
          }, [
            _createElementVNode("a", {
              class: "uk-margin-left uk-margin-top logo uk-text-left",
              href: "https://contrak.us",
              target: "_blank",
              style: {"color":"white"}
            }, " contrak "),
            _createElementVNode("h2", {
              class: "uk-margin-left uk-margin-top uk-text-left",
              style: {"color":"white"}
            }, " | "),
            _createElementVNode("h2", {
              class: "uk-margin-left uk-margin-top uk-text-left",
              style: {"color":"white"}
            }, " Customer Portal ")
          ], -1)),
          _createElementVNode("h2", null, "Orders for: " + _toDisplayString(_ctx.customer.name), 1),
          _createElementVNode("button", {
            class: "uk-button uk-button-default",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selFilter('active')))
          }, [
            _cache[9] || (_cache[9] = _createTextVNode(" Active Orders ", -1)),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.activeOrders.length), 1)
          ]),
          _createElementVNode("button", {
            class: "uk-button uk-button-default",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selFilter('complete')))
          }, [
            _cache[10] || (_cache[10] = _createTextVNode(" Completed Orders ", -1)),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.completedOrders.length), 1)
          ]),
          _createElementVNode("table", _hoisted_6, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateSortBy('orderId')))
                }, [
                  _cache[11] || (_cache[11] = _createTextVNode(" Order Reference ", -1)),
                  (_ctx.sortBy == 'orderId')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("th", {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateSortBy('orderId')))
                }, [
                  _cache[12] || (_cache[12] = _createTextVNode(" Carrier Reference ", -1)),
                  (_ctx.sortBy == 'orderId')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("th", {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateSortBy('createdOn')))
                }, [
                  _cache[13] || (_cache[13] = _createTextVNode(" Created On ", -1)),
                  (_ctx.sortBy == 'createdOn')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9))
                    : _createCommentVNode("", true)
                ]),
                _cache[19] || (_cache[19] = _createElementVNode("th", null, "Export/Import", -1)),
                _createElementVNode("th", {
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateSortBy('receiver')))
                }, [
                  _cache[14] || (_cache[14] = _createTextVNode(" Receiver Name ", -1)),
                  (_ctx.sortBy == 'receiver')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("th", {
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateSortBy('billing')))
                }, [
                  _cache[15] || (_cache[15] = _createTextVNode(" Carrier ", -1)),
                  (_ctx.sortBy == 'billing')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("th", {
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.updateSortBy('status')))
                }, [
                  _cache[16] || (_cache[16] = _createTextVNode(" Status ", -1)),
                  (_ctx.sortBy == 'status')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("th", {
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.updateSortBy('bl')))
                }, [
                  _cache[17] || (_cache[17] = _createTextVNode(" Bill Of Lading ", -1)),
                  (_ctx.sortBy == 'bl')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("th", null, [
                  _cache[18] || (_cache[18] = _createTextVNode(" # Containers ", -1)),
                  (_ctx.sortBy == 'nContainers')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_14))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.billingOrders, (order, orderIdx) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: orderIdx,
                  onClick: ($event: any) => (_ctx.selectOrder(order.id))
                }, [
                  _createElementVNode("td", _hoisted_16, _toDisplayString(order.billingReferenceNumber), 1),
                  _createElementVNode("td", _hoisted_17, _toDisplayString(order.id), 1),
                  _createElementVNode("td", _hoisted_18, _toDisplayString(order.createdAt), 1),
                  (order.isExport)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_19, [...(_cache[20] || (_cache[20] = [
                        _createElementVNode("span", { class: "uk-label uk-label-warning" }, "Export", -1)
                      ]))]))
                    : (_openBlock(), _createElementBlock("td", _hoisted_20, [...(_cache[21] || (_cache[21] = [
                        _createElementVNode("span", { class: "uk-label uk-label-light-blue" }, "Import", -1)
                      ]))])),
                  (order.customer)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_21, _toDisplayString(order.customer.name), 1))
                    : (order.receiver)
                      ? (_openBlock(), _createElementBlock("td", {
                          key: 3,
                          class: "uk-text-left",
                          "uk-tooltip": _ctx.fullAddress(order.receiver.address)
                        }, _toDisplayString(`${order.receiver.name} (${order.receiver.address.city})`), 9, _hoisted_22))
                      : _createCommentVNode("", true),
                  (order.company)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_23, _toDisplayString(order.company.name), 1))
                    : _createCommentVNode("", true),
                  (!order.status)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_24, [...(_cache[22] || (_cache[22] = [
                        _createElementVNode("span", { class: "uk-label uk-label-warning" }, "Unknown", -1)
                      ]))]))
                    : _createCommentVNode("", true),
                  _createElementVNode("td", _hoisted_25, [
                    (!order.status)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_26, "Unknown"))
                      : (order.status == 'Complete')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_27, "Complete"))
                        : (order.status === 'In Progress')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(order.status), 1))
                          : (order.status === 'Not Available')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_29, "Not Available"))
                            : (order.status === 'Cancelled')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_30, "Cancelled"))
                              : (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(order.status), 1))
                  ]),
                  (order.isExport)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_32, _toDisplayString(order.bookingNumber), 1))
                    : (order.billOfLading)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_33, _toDisplayString(order.billOfLading.billOfLadingId), 1))
                      : (_openBlock(), _createElementBlock("td", _hoisted_34, "N/A")),
                  _createElementVNode("td", _hoisted_35, _toDisplayString(order.containers.length), 1)
                ], 8, _hoisted_15))
              }), 128))
            ])
          ])
        ]))
  ]))
}